import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { X } from 'lucide-react';

/**
 * Passwordless crew login. Exchanges the magic token in the URL
 * (/crew/:magicToken) for a normal session, then redirects to the dashboard.
 * Carbon "operations cockpit" treatment.
 */
export default function MagicLoginPage({ onLogin, backendUrl }) {
  const { magicToken } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const { data } = await axios.post(`${backendUrl}/api/auth/magic/${magicToken}`);
        if (cancelled) return;
        onLogin(data.access_token, data.username, data.role);
        navigate('/', { replace: true });
      } catch (err) {
        if (cancelled) return;
        setError(err?.response?.data?.detail || 'This access link is invalid or has expired.');
      }
    };
    run();
    return () => { cancelled = true; };
  }, [magicToken, backendUrl, onLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 font-tac-body" style={{ background: '#EDEDF0' }}>
      <div className="flex flex-col items-center justify-center text-center" style={{ width: '100%', maxWidth: 440, minHeight: 480, background: '#0A0A0B', borderRadius: 16, padding: 40, boxShadow: '0 18px 48px rgba(20,20,20,0.16)' }}>
        {error ? (
          <>
            <div className="flex items-center justify-center" style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(220,38,38,0.16)', marginBottom: 22 }}>
              <X className="w-8 h-8" style={{ color: '#F87171' }} />
            </div>
            <div className="font-tac-display" style={{ fontWeight: 800, fontSize: 22, color: '#fff' }}>Link expired or invalid</div>
            <div style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.55)', margin: '10px 0 26px', maxWidth: 320, lineHeight: 1.6 }}>{error}</div>
            <button onClick={() => navigate('/login')} className="font-tac-heading" style={{ padding: '12px 20px', borderRadius: 9, border: '1px solid rgba(255,255,255,0.22)', background: 'rgba(255,255,255,0.06)', color: '#fff', fontWeight: 600, fontSize: 13.5, cursor: 'pointer' }}>
              Go to sign in
            </button>
          </>
        ) : (
          <>
            <img src="/turbo-logo-white.png" alt="Turbo 360" style={{ height: 26, width: 'auto', marginBottom: 36 }} />
            <span className="inline-block animate-spin" style={{ width: 46, height: 46, border: '3px solid rgba(255,255,255,0.14)', borderTopColor: '#BF212F', borderRadius: '50%', marginBottom: 24 }} />
            <div className="font-tac-display" style={{ fontWeight: 800, fontSize: 22, color: '#fff' }}>Signing you in…</div>
            <div style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.55)', marginTop: 10, maxWidth: 300, lineHeight: 1.6 }}>Verifying your crew link and loading your assigned galleries.</div>
          </>
        )}
      </div>
    </div>
  );
}
